import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

// style rules
import { Colors, Typography, Sizes } from "../../styles";

const TabItem = ({ filter, isActive, handleFilterSelect }) => {

	return (
		<FilterWrapper onClick={() => handleFilterSelect(filter)}>
			<Filter
				className="button--outline--green esc-button-hover"
				isActive={isActive}
			>
				{filter.title}
			</Filter>
		</FilterWrapper>
	);
};

TabItem.propTypes = {
	filter: PropTypes.object,
	isActive: PropTypes.bool,
	handleFilterSelect: PropTypes.func,
};

export default TabItem;

const FilterWrapper = styled(motion.li)`
	margin: 0;
	padding: 0;
	list-style: none;
`;

const Filter = styled.button`
	cursor: pointer;
	background: none;
	border: none;
	padding: clamp(1.5rem, 0.647vw + 1.257rem, 2.5rem)
		clamp(2rem, 0.647vw + 1.757rem, 3rem);
	font-size: clamp(1.7rem, 0.129vw + 1.651rem, 1.9rem);
	line-height: 1.1;
	letter-spacing: -0.016em;
	font-weight: ${Typography.fontWeight.semiBold};
	position: relative;
	display: inline-block;
	color: ${(props) =>
		props.isActive
			? `${Colors.base.white} !important`
			: `${Colors.fp.pineGreen} !important`};

	border-radius: 15px;
	border: 3px solid ${Colors.fp.pineGreen} !important;
	background-color: ${(props) =>
		props.isActive
			? `${Colors.fp.pineGreen} !important`
			: "transparent !important"};

	white-space: unset;
	word-wrap: break-word;
	height: 100%;
	width: 100%;

	&:hover,
	&:focus {
		color: ${Colors.base.black};
		background-color: ${Colors.fp.pineGreen};

		&::after {
			all: unset;
		}
	}

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		white-space: pre;
		height: unset;
		width: unset;
	}
`;
